import Text from "hardcover-ui/components/Text";
import DeleteAllJournalEntriesButton from "./OwnerReadingJournalButtons/DeleteAllJournalEntriesButton";
import {
  PrivacyFollows,
  PrivacyPrivate,
  PrivacyPublic,
} from "constants/PrivacySettings";
import ChangePrivacyJournalEntriesButton from "./OwnerReadingJournalButtons/ChangePrivacyJournalEntriesButton";
import { ReadingJournalSerializersJournal, PageSerializersBooksLayout } from "types/serializers";

export default function OwnerReadingJournalOptions({
  book,
  journals,
}: {
  book: PageSerializersBooksLayout;
  journals: ReadingJournalSerializersJournal[];
}) {
  return (
    <div className="p-2 h-64 lg:h-auto w-full md:w-64 inline-flex flex-col gap-2">
      <div>
        <Text variant="secondary" as="p" className="font-bold">
          {book.title}
        </Text>
        <Text variant="secondary" as="p" size="sm">
          Manage Reading Journal
        </Text>
      </div>

      <ChangePrivacyJournalEntriesButton
        journals={journals}
        privacySettingId={PrivacyPublic}
      />
      <ChangePrivacyJournalEntriesButton
        journals={journals}
        privacySettingId={PrivacyFollows}
      />
      <ChangePrivacyJournalEntriesButton
        journals={journals}
        privacySettingId={PrivacyPrivate}
      />
      <DeleteAllJournalEntriesButton book={book} />
    </div>
  );
}
